import React, { useEffect, useState } from 'react'

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wistia-player': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        'media-id': string
        aspect: string
        'aria-label'?: string
      }
    }
  }
}

export interface WistiaEmbedProps {
  mediaId: string
  aspect: string
  ariaLabel: string
}

const WistiaEmbed: React.FC<WistiaEmbedProps> = ({ mediaId, aspect, ariaLabel }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  useEffect(() => {
    // Load Wistia player script
    const script = document.createElement('script')
    script.src = 'https://fast.wistia.com/player.js'
    script.async = true
    script.onload = () => setScriptLoaded(true)
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  if (!scriptLoaded) {
    return null // Render nothing until the script is loaded
  }

  return (
    <wistia-player
      media-id={mediaId}
      aspect={aspect}
      aria-label={ariaLabel}
    ></wistia-player>
  )
}

export default WistiaEmbed
